import React, {Component} from 'react';

class FilterInput extends Component {
  render() {
    const {iconId} = this.props;

    return (
      <svg className="icon"
           aria-hidden="true">
        <use href={`/themes/custom/thp/templates/partials/_icons.svg#icon-${iconId}`}></use>
      </svg>
    );
  }
}

export default FilterInput;
